<span
  class="info-popover-trigger"
  role="button"
  tabindex="0"
  [attr.aria-label]="ariaLabel"
  (click)="open($event)"
  (keydown)="onTriggerKeydown($event)"
>
  <ion-icon [name]="icon" class="info-popover-icon"></ion-icon>
</span>

<ion-popover #popover [dismissOnSelect]="true">
  <ng-template>
    @if (message) {
      <div class="info-popover-content" [style.max-width]="maxWidth">
        {{ message }}
      </div>
    }
    <ng-content select="[popoverContent]"></ng-content>
  </ng-template>
</ion-popover>
